'use strict';

module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/react-google-autocomplete/index.js
// module id = 2883
// module chunks = 0